<template>
    <!-- <van-pull-refresh v-model="isLoading"
                    @refresh="onRefresh"> -->
    <div class="container">
        <div class="type-card">
            <div class="card-item   txt"
                 @click="toPage(1)">常见问题</div>
            <div class="card-item poper Activer"
                 @click="toPage(2)">
                <div class="more">人工通道</div>
                <div class="min">一对一服务</div>
            </div>
        </div>
        <h3 class="title">客服一对一</h3>
        <p class="tips">注：已购买人工远程刷机用户，请直接添加客服微信，并说明已购买远程刷机</p>
        <div class="pay">
            <div class="pay-main">
                <div class="pay-item pay-left">
                    <div class="img">
                        <img class="img-cover"
                             src="../assets/images/wx.png"
                             alt="">
                    </div>
                    <div class="wx-txt">扫码添加客服企业微信</div>
                </div>
                <!-- <div class="pay-item pay-right">
                    <div class="img">
                        <img class="img-cover"
                             src="../assets/images/qq.png"
                             alt="">

                    </div>
                    <div class="qq-txt">
                        <span style="color: #fff">扫码添加客服QQ</span>

                        <a style="color: #fff"
                           class="pc"
                           href="tencent://message/?uin=2163523338&Site=http://vps.shuidazhe.com&Menu=yes">扫码添加客服QQ</a>

                        <a style="color: #fff"
                           class="model"
                           href="mqqwpa://im/chat?chat_type=wpa&uin=2163523338&version=1&src_type=web&web_src=oicqzone.com">点击打开客服QQ2</a>

                    </div>
                </div> -->
            </div>
        </div>

    </div>

</template>

<script>
import Vue from 'vue';
import http from '../utils/http.js';
import { countClick } from "../common/mixin"
import { Toast } from 'vant';
Vue.use(Toast);
export default {
    name: 'index',
    mixins: [countClick], // 混入 
    data () {
        return {
            loading: false,
            finished: false,
            count: 0,
            isLoading: false,
            msg: '问题分类',
            show: false,
            list: [], //  问题列表 
            sourceList: [],
            pageIndex: 0,
            index: 0,
        }
    },
    mounted () {

        let url = "undefinedhttp://hw.xsbcdn.shuajibao.com/2021-06-08/{1841585}_小米_红米K40_alioth_images_V12.0.5.0.RKHCNXM_中国(China)_11_一键刷机_20210608094724.dx";
        if (url.indexOf('undefined') > -1) {
            let url2 = url.substring(9);
            console.log(url2);
        }


        let obj = { age: 18, name: '我计划' };
        let obj2 = JSON.stringify(obj);
        window.localStorage.setItem("cc", obj2);
        window.localStorage.setItem("n", 10);

        let cc = window.localStorage.getItem('cc');
        let n = window.localStorage.getItem('n');
        console.log(typeof n, '数据类型')
        let obj3 = JSON.parse(cc);
        console.log(obj3.age, '数据');
        // this.getData();
        this.clickEvent();
        this.getList();
        document.title = "刷机帮助";
    },
    methods: {
        toPage (v) {
            let name = '';
            if (v == 1) {
                name = 'index'
            } else if (v == 2) {
                name = 'service'
            } else {
                name = 'index'
            }
            this.$router.push({
                name: name
            })

        },
        group (array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while (index < array.length) {
                newArray.push(array.slice(index, index += subGroupLength));
            }
            return newArray;
        },
        onLoad () {
            // setTimeout(() => {
            //   // let newList = this.group(this.sourceList, 10);
            //   let newList = this.sourceList;
            //   this.pageIndex++;
            //   if (this.pageIndex < newList.length) {
            //     this.list = this.list.concat(newList[this.pageIndex]);
            //     console.log(this.list);
            //     this.loading = false;
            //   } else {
            //     this.finished = true;
            //   }

            // }, 1000);
            this.finished = true;
        },
        onRefresh () {
            setTimeout(() => {
                Toast('刷新成功');
                this.isLoading = false;
                this.count++;
            }, 1000);
        },
        goToQuest (id) {
            this.$router.push('/quest/' + id);
        },
        getList () {

            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            var url = "/feedback/flashinghelp";
            var params = {};
            http.get(url, params).then(res => {
                this.$toast.clear();
                if (res.data.code == 0) {

                    let data = res.data.data;
                    this.sourceList = data;
                    if (data.length > 10) {
                        this.list = data;
                        // 首页不做截取 
                        // this.list = data.slice(0, 10);

                    } else {
                        this.list = data;
                    }
                } else {
                    this.$toast("暂无数据")
                }
            })

        },
        onshow () {
            this.show = true;
        },
        getData () {
            var url = "/abs/dataList";
            var id = "";
            var value = "";
            var params = {
                id: id,
                key: value
            }
            http.get(url, params).then(resp => {

            })
        },
        onChange (index) {
            this.index = index;
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped>
.box {
    position: relative;
    left: 0;
    border-radius: 12px 12px 0 0;
}
.container {
    position: relative;
    padding-top: 24px;
    top: 0;
    left: 0;
}
.container .type-card {
    width: 100%;
    height: 56px;
    border-radius: 6px;
    background: rgba(240, 240, 245, 1);
    margin-bottom: 24px;
    display: flex;
    align-items: center;
}
.card-item {
    width: 50%;
    height: 50px;
    border-radius: 6px;
    cursor: pointer;
}
.type-card .txt {
    font-size: 18px;
    color: #4e5969;
    font-weight: 400;
    text-align: center;
    line-height: 56px;
}
.poper {
    color: #fff;
    text-align: center;
}
.poper .more {
    padding-top: 6px;
    font-size: 18px;
}
.poper .min {
    font-size: 12px;
}

.Activer {
    background: rgba(22, 93, 255, 1);
}
.title {
    color: #1d2129;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    padding-top: 16px;
}
.tips {
    padding-top: 8px;
    font-size: 12px;
    color: #f53f3f;
}
.pay {
    padding-top: 54px;
}
.pay .pay-item {
}
.pay .pay-main {
    width: 100%;
    display: flex;
    justify-content: center;
    /* align-items: center; */
}
.pay .pay-main .img {
    padding: 6px;
    box-sizing: border-box;
    width: 229px;
    height: 229px;
    border-radius: 8px;
}
.pay .img-cover {
    display: inline-block;
    width: 217px;
    border-radius: 6px;
}
.pay-left .img {
    background-color: #e1f2e5;
}
.pay-right .img {
    background-color: #ebf0fc;
}
.pay-right .qq-txt {
    /* cursor: pointer; */
}
.wx-txt {
    width: 196px;
    height: 40px;
    line-height: 40px;
    border-radius: 212px;
    background: #45c55e;
    font-size: 16px;
    color: #fff;
    margin: 0 auto;
    margin-top: 24px;
}
.qq-txt {
    width: 196px;
    height: 40px;
    line-height: 40px;
    border-radius: 212px;
    background: #00b6fa;
    font-size: 16px;
    color: #fff;
    margin: 0 auto;
    margin-top: 24px;
}
@media (min-width: 670px) {
    .model {
        display: none;
    }
}

@media (max-width: 670px) {
    .pc {
        display: none;
    }
    .tips {
        padding: 0 10px;
    }
    .pay .pay-main {
        display: block;
    }
    .pay .pay-item .img {
        margin: 0 auto;
    }
    .wx-txt,
    .qq-txt {
        margin-bottom: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/service.vue